import styled from 'styled-components';

export const STDHeader = styled.div`
  position: absolute;
  inset: 0;
  z-index: 9999;
`;
export const HeaderDiv = styled.div`
  width: 100%;
  height: var(--s2-one-hub-navigation-top-bar-height);
  transition: height 0.3s ease-in 0s;
  color: rgb(0, 30, 80);
  background-color: rgba(255, 255, 255); // color background
  transform: translateY(0px);
  &.headerDown {
    @media (min-width: 0px) {
      --s2-one-hub-navigation-top-bar-height: calc(16px + 24px + 12px + 32px);
    }
    @media (min-width: 560px) {
      --s2-one-hub-navigation-top-bar-height: calc(16px + 24px + 12px + 40px);
    }
    @media (min-width: 960px) {
      --s2-one-hub-navigation-top-bar-height: calc(16px + 24px + 12px + 48px);
    }
    @media (min-width: 1920px) {
      --s2-one-hub-navigation-top-bar-height: calc(16px + 24px + 12px + 56px);
    }
  }
  &.headerUp {
    @media (min-width: 0px) {
      --s2-one-hub-navigation-top-bar-height: calc(16px + 24px + 12px + 0);
    }
    @media (min-width: 560px) {
      --s2-one-hub-navigation-top-bar-height: calc(16px + 24px + 12px + 0);
    }
    @media (min-width: 960px) {
      --s2-one-hub-navigation-top-bar-height: calc(16px + 24px + 12px + 0);
    }
    @media (min-width: 1920px) {
      --s2-one-hub-navigation-top-bar-height: calc(16px + 24px + 12px + 0);
    }
  }
`;
